import { W_NS, firstKid, kids } from './ns';

// One control per document, so a fixed id is enough; the reader turns it into `fld-1`.
const FIELD_ID = '1';

const SECTION_PROPS = 'sectPr';

/**
 * Wraps the whole body in a single rich-text content control.
 *
 * Generated documents (a summary built from plain text) carry no controls, so
 * the editor would have nothing to edit. Wrapping turns the body into one
 * multiline field: the reviewer corrects the text in place, the file keeps its
 * formatting.
 *
 *   <w:body>            <w:body>
 *     <w:p/>              <w:sdt>
 *     <w:p/>       ->       <w:sdtPr>..</w:sdtPr>
 *     <w:sectPr/>           <w:sdtContent><w:p/><w:p/></w:sdtContent>
 *   </w:body>             </w:sdt>
 *                         <w:sectPr/>
 *                       </w:body>
 */
export function wrapBodyInField(part: Document, label: string): void {
  const body = firstKid(part.documentElement, 'body');
  if (!body) {
    return;
  }

  // Section setup is not content: it must stay the last child of the body.
  const blocks = Array.from(body.children).filter((el) => el.localName !== SECTION_PROPS);
  if (blocks.length === 0 || kids(body, 'sdt').length > 0) {
    return;
  }

  const sdt = part.createElementNS(W_NS, 'w:sdt');
  sdt.appendChild(makeProps(part, label));

  const content = part.createElementNS(W_NS, 'w:sdtContent');
  body.insertBefore(sdt, blocks[0]!);

  for (const block of blocks) {
    content.appendChild(block);
  }

  sdt.appendChild(content);
}

function makeProps(part: Document, label: string): Element {
  const props = part.createElementNS(W_NS, 'w:sdtPr');

  const alias = part.createElementNS(W_NS, 'w:alias');
  alias.setAttributeNS(W_NS, 'w:val', label);

  const id = part.createElementNS(W_NS, 'w:id');
  id.setAttributeNS(W_NS, 'w:val', FIELD_ID);

  props.appendChild(alias);
  props.appendChild(id);

  return props;
}
